import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = "https://newalemny.3almny.app/api";

// إنشاء محادثة جديدة
export const makeConversation = createAsyncThunk(
  "conversations/makeConversation",
  async ({ receiver_id }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) {
        return rejectWithValue("التوكن مطلوب");
      }

      const response = await fetch(`${BASE_URL}/conversations/make_conversation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ receiver_id }),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في إنشاء المحادثة");
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// جلب محادثة
export const getConversation = createAsyncThunk(
  "conversations/getConversation",
  async ({ conversation_id, page = 1 }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) {
        return rejectWithValue("التوكن مطلوب");
      }

      const response = await fetch(`${BASE_URL}/conversations/get_conversation/${conversation_id}?page=${page}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في جلب المحادثة");
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// إرسال رسالة
export const sendMessage = createAsyncThunk(
  "conversations/sendMessage",
  async ({ conversation_id, message }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) {
        return rejectWithValue("التوكن مطلوب");
      }

      const response = await fetch(`${BASE_URL}/conversations/send_message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ conversation_id, message }),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في إرسال الرسالة");
      }

      return data.result;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

const conversationsSlice = createSlice({
  name: "conversations",
  initialState: {
    currentConversation: null,
    messages: [],
    conversationLoading: false,
    conversationError: null,
    sendMessageLoading: false,
    sendMessageError: null,
    makeConversationLoading: false,
    makeConversationError: null,
    makeConversationSuccess: false,
  },
  reducers: {
    clearConversationError: (state) => {
      state.conversationError = null;
    },
    clearSendMessageError: (state) => {
      state.sendMessageError = null;
    },
    clearMakeConversationError: (state) => {
      state.makeConversationError = null;
    },
    resetConversationState: (state) => {
      state.currentConversation = null;
      state.messages = [];
      state.conversationLoading = false;
      state.conversationError = null;
      state.sendMessageLoading = false;
      state.sendMessageError = null;
      state.makeConversationLoading = false;
      state.makeConversationError = null;
      state.makeConversationSuccess = false;
    },
    addMessageToConversation: (state, action) => {
      state.messages.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    // Make Conversation
    builder
      .addCase(makeConversation.pending, (state) => {
        state.makeConversationLoading = true;
        state.makeConversationError = null;
        state.makeConversationSuccess = false;
      })
      .addCase(makeConversation.fulfilled, (state, action) => {
        state.makeConversationLoading = false;
        console.log('makeConversation.fulfilled - action.payload:', action.payload);
        // إنشاء كائن المحادثة مع ID الصحيح
        state.currentConversation = {
          id: action.payload.result,
          receiver_id: action.payload.receiver_id || null
        };
        state.makeConversationSuccess = true;
      })
      .addCase(makeConversation.rejected, (state, action) => {
        state.makeConversationLoading = false;
        state.makeConversationError = action.payload;
        state.makeConversationSuccess = false;
      });

    // Get Conversation
    builder
      .addCase(getConversation.pending, (state) => {
        state.conversationLoading = true;
        state.conversationError = null;
      })
      .addCase(getConversation.fulfilled, (state, action) => {
        state.conversationLoading = false;
        // حفظ الرسائل مع الـ structure الكامل
        state.messages = action.payload;
      })
      .addCase(getConversation.rejected, (state, action) => {
        state.conversationLoading = false;
        state.conversationError = action.payload;
      });

    // Send Message
    builder
      .addCase(sendMessage.pending, (state) => {
        state.sendMessageLoading = true;
        state.sendMessageError = null;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.sendMessageLoading = false;
        // إضافة الرسالة الجديدة للمحادثة
        if (action.payload.message) {
          state.messages.push(action.payload.message);
        }
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.sendMessageLoading = false;
        state.sendMessageError = action.payload;
      });
  },
});

export const { 
  clearConversationError, 
  clearSendMessageError, 
  clearMakeConversationError,
  resetConversationState,
  addMessageToConversation
} = conversationsSlice.actions;

export default conversationsSlice.reducer;
